module.exports = __webpack_public_path__ + "static/media/knet.1a095203.webp";